export default {
	mounted() {
		const oauthStatus = this.$router.currentRoute.query.oauth;

		if (!oauthStatus) return;

		if (oauthStatus !== 'success') {
			this.$toast.show({
				type: 'danger',
				message: this.$t('account_stellenbosch_sync_error'),
			});

			return;
		}

		this.$toast.show({
			type: 'success',
			message: this.$t('account_stellenbosch_sync_success'),
		});

		this.$router
			.replace(this.localePath({ path: this.$route.path }))
			.catch(() => {
				console.log('Navigation cancelled.');
			});
	},
}
